import React from 'react';
import { LinearProgress } from '@mui/material';
import { TestCount } from 'libs/end-to-end/src/tests-utils';
import { getCalibrationLevel } from 'libs/end-to-end/src/calibration-level';
import { getCalibrationScore } from 'libs/end-to-end/src/tests-utils';
import { getCalibrationLevelUIDetails } from 'libs/end-to-end/src/ui';

export const OptimizationTestProgressBar = ({
  testResult,
}: {
  testResult: TestCount;
}) => {
  // Optimization is used here since the bar is representative of the test counts, and it would be confusing to use bias.
  const calibrationScore = getCalibrationScore({
    testCount: testResult,
  });
  const calibrationLevel = getCalibrationLevel(calibrationScore);
  const { bgColor } =
    getCalibrationLevelUIDetails('optimization')[calibrationLevel];
  const barValue = (calibrationScore / 6) * 100;

  return (
    <LinearProgress
      variant="determinate"
      className="rounded-full h-2 bg-gray-100"
      classes={{
        barColorPrimary: bgColor,
        bar: 'rounded-full',
      }}
      value={barValue}
    />
  );
};
